<template>
  <div>
    <div>
      <common-card
        :style="{ 'min-height': getCollapseheight() }"
        :title="selectedStack.no"
      >
        <basic-form
          class="selected-stack-info"
          ref="selectedStackForm"
          :mode="FormModes.SPARSE"
          :form-params="StackInfoWrapUp(selectedStack)"
        >
        </basic-form>
        <div class="f-r selected-stack-detail">
          <div
            class="selected-stack-grids f-r"
            :style="{
              'max-width': getSectionWidth(selectedStack.slotPerSection)
            }"
          >
            <div
              v-for="slot in selectedStack.slots"
              :key="slot.no"
              class="slot-name"
              :class="{
                selected: selectedSlot && slot.no === selectedSlot.no
              }"
              @click="selectedSlot = slot"
            >
              {{ slot.no }}
            </div>
          </div>
          <div class="selected-stack-sections">
            <el-button
              size="small"
              type="text"
              @click="labelStack(selectedStack.no)"
            >
              All Labels
            </el-button>
            <div v-if="selectedSlot">
              <div class="pallet-chip-container">
                <div
                  class="pallet-chip"
                  :class="getPalletStatus(pallet)"
                  v-for="pallet in selectedSlot.pallets"
                  :key="pallet.id"
                >
                  <svg-icon
                    icon-class="lock"
                    v-if="pallet.hold === 'True'"
                    class="icon"
                  />
                  <el-popover
                    trigger="click"
                    placement="top-start"
                    @mouseenter.native="getQrSrc(pallet)"
                  >
                    <img :src="qrSrc" />
                    <span class="title" slot="reference">
                      {{ pallet.no }}
                    </span>
                  </el-popover>
                  <svg-icon
                    icon-class="info"
                    @click.native="goToPalletDetail(pallet.no)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </common-card>
    </div>
    <slot-label-dialog ref="slotLabelDialog"></slot-label-dialog>
  </div>
</template>

<script>
// apis
import { labelStack } from '@/api/stack'
// types
import { StackInfoWrapUp } from '@/core/models/stack'
import { FormModes } from '@/core/configs/types'
// components
import CommonCard from '@/components/common/CommonCard.vue'
import BasicForm from '@/components/common/BasicForm.vue'
import SlotLabelDialog from '@/components/stack/SlotLabelDialog.vue'
// models
import { MediumPallet, HighPallet } from '@/core/models/pallet'
// mixin
import { pageJumps } from '@/core/mixin/pages'
import { viewPdf } from '@/core/utils'
import { queryPallets } from '@/api/pallet'

const QRCode = require('qrcode')

export default {
  props: {
    selectedStack: {
      type: Object,
      required: true
    }
  },
  mixins: [pageJumps],
  components: {
    CommonCard,
    BasicForm,
    SlotLabelDialog
  },
  data() {
    return {
      FormModes,
      selectedSlot: null,
      HighPallet,
      MediumPallet,
      qrSrc: ''
    }
  },
  watch: {
    selectedSlot() {
      if (this.selectedSlot) this.getSlotPallets()
    }
  },
  methods: {
    StackInfoWrapUp,
    getCollapseheight() {
      if (this.selectedStack) {
        const num = this.selectedStack.sectionNum
        return 135 + num * 45 + (num - 1) * 5 + 'px'
      } else {
        return '150px'
      }
    },
    getSectionWidth(num) {
      return 124 * num + (num - 1) * 5 + 'px'
    },
    openSlotLabelDialog(slot, stack) {
      this.$refs.slotLabelDialog.open(slot, stack)
    },
    getPalletStatus(pallet) {
      return pallet.status.toLowerCase()
    },
    async getQrSrc(pallet) {
      const src = await QRCode.toDataURL(
        JSON.stringify({
          type: 'Pallet',
          id: pallet.id,
          no: pallet.no
        })
      )
      this.$set(this, 'qrSrc', src)
    },
    async labelStack(stackNo) {
      // download stack label
      const blob = await labelStack(stackNo)
      viewPdf(blob)
    },
    async getSlotPallets() {
      queryPallets({ slotNos: [this.selectedSlot.no], size: -1 }).then(res => {
        this.$set(this.selectedSlot, 'pallets', res.records)
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.common-card {
  margin: 0;
}

.selected-stack-info {
  padding: 0;
  box-shadow: none;

  ::v-deep .common-card__header {
    display: none;
  }
}

.selected-stack-detail {
  width: 100%;
  gap: 20px;
}

.selected-stack-grids {
  gap: 5px;
  flex-wrap: wrap;

  .slot-name {
    border: 2px solid $business-color;
    background-color: rgba($business-color, 0.1);
    padding: 10px !important;
    border-radius: 3px;
    width: 100px;
    text-align: center;
    font-size: 18px;
    color: $business-color;
    font-weight: bold;

    &:hover {
      cursor: pointer;
      background-color: rgba($business-color, 0.3);
    }

    &.selected {
      background-color: $business-color;
      color: white;
      height: 20.5px;
    }
  }
}

.pallet-chip-container {
  @extend .f-r;

  flex-wrap: wrap;
  gap: 10px;

  .pallet-chip {
    user-select: none;
    padding: 10px 15px;
    gap: 5px;
    border: 1px solid;
    border-radius: 5px;
    background: white;

    @extend .f-r-c-c;

    .title {
      font-weight: bold;
      padding: 0;
    }

    .icon {
      font-size: 18px;

      &.add:active {
        color: $el-danger-color;
      }
    }

    &:hover {
      cursor: pointer;
    }
  }
}

.offstack {
  color: $deep-green;

  .svg-icon {
    filter: $svg-success-color;
  }
}

.offstack:hover {
  background-color: $deep-green;
}

.onstack {
  color: $business-color;

  .svg-icon {
    filter: $svg-business-color;
  }

  &:hover {
    background-color: $business-color;
  }
}

.upcoming {
  color: $deep-warning;

  .svg-icon {
    filter: $svg-warning-color;
  }

  &:hover {
    background-color: $deep-warning;
  }
}

.delivered,
.shipping {
  color: $info-color;

  .svg-icon {
    filter: $svg-info-color;
  }

  &:hover {
    background-color: $info-color;
  }
}

.offstack:hover,
.onstack:hover,
.upcoming:hover,
.delivered:hover,
.shipping:hover {
  color: white;

  .svg-icon {
    filter: $svg-white;
  }
}
</style>
